import React from 'react';

/**
 * PageWrapper - Ensures consistent layout and styling across all pages
 * Provides consistent spacing, animations, and responsive design
 */
const PageWrapper = ({ children, className = '', title, subtitle, actions }) => {
  return (
    <div className={`animate-fade-in ${className}`}>
      {/* Page Header */}
      {(title || subtitle || actions) && (
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 animate-slide-up">
          <div>
            {title && (
              <h1 className="text-2xl sm:text-3xl font-display font-bold text-gray-900 mb-1">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-sm sm:text-base text-gray-600 mt-1">
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      )}

      {/* Page Content */}
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;

